import { useDispatch, useSelector } from "react-redux";
import { getEditorTitle, isEditorDetached } from "components/store/application.reducers";
import { editorReattach } from "components/taskdetails-remake/taskDetails.action";
import NewWindow from "components/taskdetails-remake/panels/attachments/detached/NewWindow";
import DocumentEditorPanel from "components/taskdetails-remake/panels/editor/DocumentEditorPanel.component";
import AccountingGridPanel from "components/taskdetails-remake/panels/editor/AccountingGridPanel.component";
import { productWindowTitle } from "utils/productName.function";

export function DocumentEditorWindow(props: any) {
    const { onKeyPress } = props;
    const dispatch = useDispatch();
    const isDetached = useSelector(isEditorDetached);
    const editorTitle = useSelector(getEditorTitle);
    const width = parseInt(window.localStorage.getItem(`@@grid/editor-width`)) || 1200;
    const height = document?.body.clientHeight || 800;

    function onOpen() {
        window.onbeforeunload = onUnload;
    }

    function onUnload() {
        dispatch(editorReattach());
        window.onbeforeunload = null;
    }

    if (!isDetached) {
        return null;
    }

    const externalEditorAvailable = props.taskDetails?.externalEditorAvailable;
    const accountingGridVisible = props.task?.hasAccountingGrid || props.task?.allowGridEdit || props.taskDetails?.allowGridEdit;
    const hasContent = externalEditorAvailable || accountingGridVisible;

    return (
        <div>
            <NewWindow features={{width: width, height: height, location: false}}
                       title={editorTitle || productWindowTitle()}
                       name={"DocumentEditorWindow"}
                       onOpen={onOpen}
                       onKeyPress={onKeyPress}
                       onUnload={onUnload}>
                <div className={"d-flex flex-column editor-detached-window w-100 h-100"}>
                    {externalEditorAvailable &&
                        <DocumentEditorPanel {...props}
                                             renderInPortal={false}
                                             inDetachedWindow={true}/>
                    }
                    {accountingGridVisible &&
                        <AccountingGridPanel {...props}
                                             renderInPortal={false}
                                             inDetachedWindow={true}/>
                    }
                    {!hasContent &&
                        <div className="editor-detached-window__empty d-flex align-items-center justify-content-center w-100 h-100">
                            {props.translate("taskDetail.noEditorAvailable")}
                        </div>
                    }
                </div>
            </NewWindow>
        </div>
    );
}

export default DocumentEditorWindow;
